import { trackCsEvent } from 'app/client/analytics';
import { getEnvelope } from 'app/client/analytics/utils';

// TODO: Combine redudant code
type TriggerLocations = 'hp_homepage' | 'post_contact_popup' | 'search_results';
type TriggerObjects =
  | 'info_cards'
  | 'hp_home_page_component|search'
  | 'filter_panel'
  | 'post_contact_popup|alerts_modal';
type BedRoomFilterObjects = 'filter_panel' | 'info_cards';

// https://dataportal.zillowgroup.net/event-registry/5816
export const emitTrackBedroomFilterEvent = ({
  triggerLocation,
  triggerObject,
}: {
  triggerLocation: TriggerLocations;
  triggerObject: BedRoomFilterObjects;
}) => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5816',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'bedroom_filter',
      trigger_object_nm: triggerObject,
    },
    semantic: {
      semantic_event_nm: 'bedroom_filter',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5817
export const emitTrackBathroomFilterEvent = ({ triggerLocation }: { triggerLocation: TriggerLocations }) => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5817',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'bathroom_filter',
      trigger_object_nm: 'filter_panel',
    },
    semantic: {
      semantic_event_nm: 'bathroom_filter',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5818
export const emitTrackPetsFilterEvent = ({ triggerLocation }: { triggerLocation: TriggerLocations }) => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5818',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'pets_filter',
      trigger_object_nm: 'filter_panel',
    },
    semantic: {
      semantic_event_nm: 'pets_filter',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5819
export const emitTrackLowPriceFilterEvent = ({
  triggerLocation,
  triggerObject,
}: {
  triggerLocation: TriggerLocations;
  triggerObject: TriggerObjects;
}) => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5819',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'low_price_slider',
      trigger_object_nm: triggerObject,
    },
    semantic: {
      semantic_event_nm: 'low_price_filter',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5820
export const emitTrackHighPriceFilterEvent = ({
  triggerLocation,
  triggerObject,
}: {
  triggerLocation: TriggerLocations;
  triggerObject: TriggerObjects;
}) => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5820',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'high_price_slider',
      trigger_object_nm: triggerObject,
    },
    semantic: {
      semantic_event_nm: 'high_price_filter',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5884
export const emitTrackLaundryFilterEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5884',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'search_results',
      trigger_source_nm: 'laundry_filter_checkbox',
      trigger_object_nm: 'filter_panel',
    },
    semantic: {
      semantic_event_nm: 'laundry_filter',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5885
export const emitTrackAcFilterEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5885',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'search_results',
      trigger_source_nm: 'ac_filter_checkbox',
      trigger_object_nm: 'filter_panel',
    },
    semantic: {
      semantic_event_nm: 'ac_filter',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5886
export const emitTrackHeatingFilterEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5886',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'search_results',
      trigger_source_nm: 'heating_filter_checkbox',
      trigger_object_nm: 'filter_panel',
    },
    semantic: {
      semantic_event_nm: 'heating_filter',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5887
export const emitTrackParkingFilterEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5887',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'search_results',
      trigger_source_nm: 'parking_filter_checkbox',
      trigger_object_nm: 'filter_panel',
    },
    semantic: {
      semantic_event_nm: 'parking_filter',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5888
export const emitTrackGatedFilterEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5888',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'search_results',
      trigger_source_nm: 'gated_entry_filter_checkbox',
      trigger_object_nm: 'filter_panel',
    },
    semantic: {
      semantic_event_nm: 'gated_entry_filter',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5889
export const emitTrackDoormanFilterEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5889',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'search_results',
      trigger_source_nm: 'doorman_filter_checkbox',
      trigger_object_nm: 'filter_panel',
    },
    semantic: {
      semantic_event_nm: 'doorman_filter',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5891
export const emitTrackGymFilterEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5891',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'search_results',
      trigger_source_nm: 'gym_filter_checkbox',
      trigger_object_nm: 'filter_panel',
    },
    semantic: {
      semantic_event_nm: 'gym_filter_interaction',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5893
export const emitTrackPoolFilterEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5893',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'search_results',
      trigger_source_nm: 'pool_filter_checkbox',
      trigger_object_nm: 'filter_panel',
    },
    semantic: {
      semantic_event_nm: 'pool_filter',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5894
export const emitTrackDishwasherFilterEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5894',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'search_results',
      trigger_source_nm: 'dishwasher_filter_checkbox',
      trigger_object_nm: 'filter_panel',
    },
    semantic: {
      semantic_event_nm: 'dishwasher_filter',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5895
export const emitTrackFurnishedEventEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5895',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'search_results',
      trigger_source_nm: 'furnished_filter_checkbox',
      trigger_object_nm: 'filter_panel',
    },
    semantic: {
      semantic_event_nm: 'furnished_filter',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5992
export const emitTrackResetFilterEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5992',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'hp_homepage',
      trigger_source_nm: 'link_to_reset_filters',
      trigger_object_nm: 'hp_home_page_component|search',
    },
    semantic: {
      semantic_event_nm: 'reset_filter',
      topic_tag_txt: [],
    },
  });
};
